import { useEffect } from "react";

import { useSelectedProject } from "modules/projects/hooks/useSelectedProject";
import { useAuthUserQuery } from "modules/user/hooks/queries/useAuthUserQuery";

import { getSubdomain } from "../utils/helpers";

const APP_ID = import.meta.env.REACT_APP_HELPCRUNCH_APP_ID;

export const useHelpCrunch = () => {
  const { data: userData } = useAuthUserQuery();
  const { selectedProject } = useSelectedProject();

  const subdomain = getSubdomain();

  const companyName = selectedProject?.company?.name;

  useEffect(() => {
    if (!userData || import.meta.env.DEV) return;

    const script = document.createElement("script");
    script.type = "text/javascript";

    const settings = {
      organization: "efestra",
      appId: APP_ID,
      showWidget: true,
      user: {
        user_id: userData.id,
        email: userData.email,
        name: `${userData.name} ${userData.surname}`,
        company: companyName,
        custom_data: {
          subdomain,
          sign_up_date: userData.created_at,
          user_role: userData.user_role,
          window_width: window && window.innerWidth ? window.innerWidth : null,
          window_height:
            window && window.innerHeight ? window.innerHeight : null,
          best_role: userData.best_role,
          master_account_status: userData.master_account_status
        }
      }
    };

    script.innerHTML = `
      HelpCrunch('init', 'efestra', ${JSON.stringify(settings)});
      HelpCrunch('showChatWidget');
    `;

    document.body.appendChild(script);
  }, [companyName, subdomain, userData]);
};
